/**
 * ## useGetSelectOption
 * - select option을 가져오는 Hook
 */

// prettier-ignore
const useGetSelectOption = () => {
  // 사용 여부
  const getUseYn = () => {
    return [
      { value: true, label: '사용' },
      { value: false, label: '미사용' },
    ];
  };

 
  // 배너 링크 타겟
  const getBannerLinkTypeCdType = () => {
    return [
      { value: 901401, label: '현재창' },
      { value: 901402, label: '새창' },
    ];
  };

  // 언어
  const getLang = () => {
    return [
      { value: 'ko', label: '한국어' },
      { value: 'en', label: '영어' },
    ];
  };

  // 팝업 노출 환경
  const getEnvironment = () => {
    return [
      { value: 'web', label: 'WEB' },
      { value: 'mobile', label: 'MOBILE' },
    ];
  };

  // 이벤트 카테고리
 const getEventCategory = () => {
   return [
     { value: 11, label: '국내 IR' },
     { value: 22, label: '국내 NDR' },
     { value: 33, label: '경영 실적 발표' },
    //  { value: 'domestic_ir', label: '국내 IR' },
    //  { value: 'domestic_ndr', label: '국내 NDR' },
    //  { value: 'earnings_announcement', label: '경영 실적 발표' },
   ];
 };

  return {
    getUseYn,
    getBannerLinkTypeCdType,
    getLang,
    getEnvironment,
    getEventCategory,
  };
};

export default useGetSelectOption;
